/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContractPayloadDto
 */
export interface UpdateContractPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    binderId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    reinsuredId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    brokerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    binderShareQuoted?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    binderShareSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    contractStatus?: UpdateContractPayloadDtoContractStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof UpdateContractPayloadDto
     */
    bindingDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    premiumPaymentWarranty?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    brokerReference?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractPayloadDto
     */
    installments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractPayloadDto
     */
    incidental?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateContractPayloadDto
     */
    incidentalCountry?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    underwritingComments?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    rateMovement?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    originalRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    adjustedRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    notesAndEndorsements?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    cedingCommissionRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    sourceBrokerageRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    ereRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    withholdingTaxRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    taxAndFeeAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    otherDeductions?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    gstOnEre?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    competitorRateOnExposure?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    competitorRateOnLine?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateContractPayloadDto
     */
    noticeOfCancellationPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    closingReason?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    pinnacleReferenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    oldPinReferenceNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateContractPayloadDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    aitRate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    gstRateOnCedingCommission?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    gstRateOnSourceBrokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    underwriter?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    totalTiv?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    ntuReason?: UpdateContractPayloadDtoNtuReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractPayloadDto
     */
    isDeclaration?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractPayloadDto
     */
    stockDeclaration?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    layerPremium?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    rateAdequacy?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    basisOfCover?: UpdateContractPayloadDtoBasisOfCoverEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    transactionType?: UpdateContractPayloadDtoTransactionTypeEnum;
    /**
     * Policy type for the contract
     * @type {string}
     * @memberof UpdateContractPayloadDto
     */
    policyType?: UpdateContractPayloadDtoPolicyTypeEnum;
}


/**
 * @export
 */
export const UpdateContractPayloadDtoContractStatusEnum = {
    Bound: 'Bound',
    NotTakenUp: 'Not Taken Up',
    Cancelled: 'Cancelled',
    Quoted: 'Quoted',
    Pending: 'Pending'
} as const;
export type UpdateContractPayloadDtoContractStatusEnum = typeof UpdateContractPayloadDtoContractStatusEnum[keyof typeof UpdateContractPayloadDtoContractStatusEnum];

/**
 * @export
 */
export const UpdateContractPayloadDtoNtuReasonEnum = {
    Price: 'NTU - Price',
    Unsuccessful: 'NTU - Unsuccessful',
    NoResponse: 'NTU - No response',
    Other: 'NTU - Other'
} as const;
export type UpdateContractPayloadDtoNtuReasonEnum = typeof UpdateContractPayloadDtoNtuReasonEnum[keyof typeof UpdateContractPayloadDtoNtuReasonEnum];

/**
 * @export
 */
export const UpdateContractPayloadDtoBasisOfCoverEnum = {
    AnyOneEvent: 'Any One Event',
    AnyOneLocation: 'Any One Location',
    InTheAggregate: 'In the Aggregate'
} as const;
export type UpdateContractPayloadDtoBasisOfCoverEnum = typeof UpdateContractPayloadDtoBasisOfCoverEnum[keyof typeof UpdateContractPayloadDtoBasisOfCoverEnum];

/**
 * @export
 */
export const UpdateContractPayloadDtoTransactionTypeEnum = {
    Renewal: 'Renewal',
    NewBusiness: 'New Business'
} as const;
export type UpdateContractPayloadDtoTransactionTypeEnum = typeof UpdateContractPayloadDtoTransactionTypeEnum[keyof typeof UpdateContractPayloadDtoTransactionTypeEnum];

/**
 * @export
 */
export const UpdateContractPayloadDtoPolicyTypeEnum = {
    Reinsurance: 'Reinsurance',
    Insurance: 'Insurance'
} as const;
export type UpdateContractPayloadDtoPolicyTypeEnum = typeof UpdateContractPayloadDtoPolicyTypeEnum[keyof typeof UpdateContractPayloadDtoPolicyTypeEnum];


/**
 * Check if a given object implements the UpdateContractPayloadDto interface.
 */
export function instanceOfUpdateContractPayloadDto(value: object): value is UpdateContractPayloadDto {
    return true;
}

export function UpdateContractPayloadDtoFromJSON(json: any): UpdateContractPayloadDto {
    return UpdateContractPayloadDtoFromJSONTyped(json, false);
}

export function UpdateContractPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContractPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'binderId': json['binderId'] == null ? undefined : json['binderId'],
        'reinsuredId': json['reinsuredId'] == null ? undefined : json['reinsuredId'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'binderShareQuoted': json['binderShareQuoted'] == null ? undefined : json['binderShareQuoted'],
        'binderShareSigned': json['binderShareSigned'] == null ? undefined : json['binderShareSigned'],
        'contractStatus': json['contractStatus'] == null ? undefined : json['contractStatus'],
        'bindingDate': json['bindingDate'] == null ? undefined : (new Date(json['bindingDate'])),
        'premiumPaymentWarranty': json['premiumPaymentWarranty'] == null ? undefined : json['premiumPaymentWarranty'],
        'brokerReference': json['brokerReference'] == null ? undefined : json['brokerReference'],
        'installments': json['installments'] == null ? undefined : json['installments'],
        'incidental': json['incidental'] == null ? undefined : json['incidental'],
        'incidentalCountry': json['incidentalCountry'] == null ? undefined : json['incidentalCountry'],
        'underwritingComments': json['underwritingComments'] == null ? undefined : json['underwritingComments'],
        'rateMovement': json['rateMovement'] == null ? undefined : json['rateMovement'],
        'originalRate': json['originalRate'] == null ? undefined : json['originalRate'],
        'adjustedRate': json['adjustedRate'] == null ? undefined : json['adjustedRate'],
        'notesAndEndorsements': json['notesAndEndorsements'] == null ? undefined : json['notesAndEndorsements'],
        'cedingCommissionRate': json['cedingCommissionRate'] == null ? undefined : json['cedingCommissionRate'],
        'sourceBrokerageRate': json['sourceBrokerageRate'] == null ? undefined : json['sourceBrokerageRate'],
        'ereRate': json['ereRate'] == null ? undefined : json['ereRate'],
        'withholdingTaxRate': json['withholdingTaxRate'] == null ? undefined : json['withholdingTaxRate'],
        'taxAndFeeAmount': json['taxAndFeeAmount'] == null ? undefined : json['taxAndFeeAmount'],
        'otherDeductions': json['otherDeductions'] == null ? undefined : json['otherDeductions'],
        'gstOnEre': json['gstOnEre'] == null ? undefined : json['gstOnEre'],
        'competitorRateOnExposure': json['competitorRateOnExposure'] == null ? undefined : json['competitorRateOnExposure'],
        'competitorRateOnLine': json['competitorRateOnLine'] == null ? undefined : json['competitorRateOnLine'],
        'noticeOfCancellationPeriod': json['noticeOfCancellationPeriod'] == null ? undefined : json['noticeOfCancellationPeriod'],
        'closingReason': json['closingReason'] == null ? undefined : json['closingReason'],
        'pinnacleReferenceNumber': json['pinnacleReferenceNumber'] == null ? undefined : json['pinnacleReferenceNumber'],
        'oldPinReferenceNumber': json['oldPinReferenceNumber'] == null ? undefined : json['oldPinReferenceNumber'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'aitRate': json['aitRate'] == null ? undefined : json['aitRate'],
        'gstRateOnCedingCommission': json['gstRateOnCedingCommission'] == null ? undefined : json['gstRateOnCedingCommission'],
        'gstRateOnSourceBrokerage': json['gstRateOnSourceBrokerage'] == null ? undefined : json['gstRateOnSourceBrokerage'],
        'underwriter': json['underwriter'] == null ? undefined : json['underwriter'],
        'totalTiv': json['totalTiv'] == null ? undefined : json['totalTiv'],
        'ntuReason': json['ntuReason'] == null ? undefined : json['ntuReason'],
        'isDeclaration': json['isDeclaration'] == null ? undefined : json['isDeclaration'],
        'stockDeclaration': json['stockDeclaration'] == null ? undefined : json['stockDeclaration'],
        'layerPremium': json['layerPremium'] == null ? undefined : json['layerPremium'],
        'rateAdequacy': json['rateAdequacy'] == null ? undefined : json['rateAdequacy'],
        'basisOfCover': json['basisOfCover'] == null ? undefined : json['basisOfCover'],
        'transactionType': json['transactionType'] == null ? undefined : json['transactionType'],
        'policyType': json['policyType'] == null ? undefined : json['policyType'],
    };
}

export function UpdateContractPayloadDtoToJSON(json: any): UpdateContractPayloadDto {
    return UpdateContractPayloadDtoToJSONTyped(json, false);
}

export function UpdateContractPayloadDtoToJSONTyped(value?: UpdateContractPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'binderId': value['binderId'],
        'reinsuredId': value['reinsuredId'],
        'brokerId': value['brokerId'],
        'binderShareQuoted': value['binderShareQuoted'],
        'binderShareSigned': value['binderShareSigned'],
        'contractStatus': value['contractStatus'],
        'bindingDate': value['bindingDate'] == null ? undefined : ((value['bindingDate']).toISOString()),
        'premiumPaymentWarranty': value['premiumPaymentWarranty'],
        'brokerReference': value['brokerReference'],
        'installments': value['installments'],
        'incidental': value['incidental'],
        'incidentalCountry': value['incidentalCountry'],
        'underwritingComments': value['underwritingComments'],
        'rateMovement': value['rateMovement'],
        'originalRate': value['originalRate'],
        'adjustedRate': value['adjustedRate'],
        'notesAndEndorsements': value['notesAndEndorsements'],
        'cedingCommissionRate': value['cedingCommissionRate'],
        'sourceBrokerageRate': value['sourceBrokerageRate'],
        'ereRate': value['ereRate'],
        'withholdingTaxRate': value['withholdingTaxRate'],
        'taxAndFeeAmount': value['taxAndFeeAmount'],
        'otherDeductions': value['otherDeductions'],
        'gstOnEre': value['gstOnEre'],
        'competitorRateOnExposure': value['competitorRateOnExposure'],
        'competitorRateOnLine': value['competitorRateOnLine'],
        'noticeOfCancellationPeriod': value['noticeOfCancellationPeriod'],
        'closingReason': value['closingReason'],
        'pinnacleReferenceNumber': value['pinnacleReferenceNumber'],
        'oldPinReferenceNumber': value['oldPinReferenceNumber'],
        'fileIds': value['fileIds'],
        'aitRate': value['aitRate'],
        'gstRateOnCedingCommission': value['gstRateOnCedingCommission'],
        'gstRateOnSourceBrokerage': value['gstRateOnSourceBrokerage'],
        'underwriter': value['underwriter'],
        'totalTiv': value['totalTiv'],
        'ntuReason': value['ntuReason'],
        'isDeclaration': value['isDeclaration'],
        'stockDeclaration': value['stockDeclaration'],
        'layerPremium': value['layerPremium'],
        'rateAdequacy': value['rateAdequacy'],
        'basisOfCover': value['basisOfCover'],
        'transactionType': value['transactionType'],
        'policyType': value['policyType'],
    };
}

